import { useEffect, useRef } from 'react';

import { saveDeliveryAddressIfRequested } from 'features/store/pages/delivery-store-selector/save-delivery-address-if-requested';

import { useAuthContext } from 'state/auth';
import { useOrderContext } from 'state/order';

export function useSavePendingDeliveryAddress() {
  const { user, saveDeliveryAddress } = useAuthContext();
  const {
    deliveryAddress,
    formShouldSaveDeliveryAddress,
    orderPhoneNumber,
    setFormShouldSaveDeliveryAddress,
    setShouldSaveDeliveryAddress,
    updateShouldSaveDeliveryAddress,
  } = useOrderContext();
  const hasAttemptedSave = useRef(false);

  useEffect(() => {
    const isAuthenticated = Boolean(user?.cognitoId && user?.details);
    const canSave =
      !hasAttemptedSave.current &&
      formShouldSaveDeliveryAddress &&
      Boolean(deliveryAddress?.addressLine1) &&
      isAuthenticated;

    if (!canSave || !deliveryAddress) {
      return;
    }

    hasAttemptedSave.current = true;

    const persistPendingAddress = async () => {
      const didSave = await saveDeliveryAddressIfRequested({
        shouldSave: formShouldSaveDeliveryAddress,
        user,
        address: deliveryAddress,
        phoneNumber: orderPhoneNumber,
        saveDeliveryAddress,
      });

      if (!didSave) {
        return;
      }

      setFormShouldSaveDeliveryAddress(false);
      setShouldSaveDeliveryAddress(false);
      updateShouldSaveDeliveryAddress(false);
    };

    void persistPendingAddress();
  }, [
    deliveryAddress,
    formShouldSaveDeliveryAddress,
    orderPhoneNumber,
    saveDeliveryAddress,
    setFormShouldSaveDeliveryAddress,
    setShouldSaveDeliveryAddress,
    updateShouldSaveDeliveryAddress,
    user,
  ]);
}
